import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,

  props: ['labels', 'data'],

  data () {
    return {
      chartData: null,
      options: {
      }
    }
  },

  mounted () {
    const randomColors = this.data.map(() => {
      return this.chartColors[Math.floor(Math.random() * this.chartColors.length)]
    })

    this.chartData = {
      labels: this.labels,
      datasets: [{
        data: this.data,
        backgroundColor: randomColors
      }]
    }

    this.renderChart(this.chartData, this.options)
  },

  computed: {
    chartColors () {
      return this.$store.getters.chartColors
    }
  }
}
